import { Project, ProjectPlan, Tag } from './types';

export const ROOM_LABEL = (count: 0 | 1 | 2 | 3 | 4) =>
  count === 0 ? 'Studio' : `${count} otaqlı`;

export const TAG_LABELS: Record<Tag, string> = {
  cash: 'Öz vəsaiti hesabına',
  mortgage: 'İpoteka krediti hesabına'
};

/** Map an API `ProjectPlan` → the UI `Project` shape consumed by
 *  `ProjectCard` / `ProjectGrid` / search panels.
 *
 *  `lang` selects the localized name (defaults to Azerbaijani — the
 *  Figma copy is in az). */
export function projectFromPlan(
  plan: ProjectPlan,
  lang: 'az' | 'en' | 'ru' = 'az',
): Project {
  /* Cash + mortgage pills are driven by each plan's own API flags. */
  const tags: Tag[] = [];
  if (plan.is_cash_purchase_available) tags.push('cash');
  if (plan.is_mortgage_purchase_available) tags.push('mortgage');

  const rooms: Project['rooms'] = {};
  if (plan.sale_1room_count > 0) rooms[1] = plan.sale_1room_count;
  if (plan.sale_2room_count > 0) rooms[2] = plan.sale_2room_count;
  if (plan.sale_3room_count > 0) rooms[3] = plan.sale_3room_count;
  if (plan.sale_4room_count > 0) rooms[4] = plan.sale_4room_count;

  const name =
    lang === 'en' ? plan.name_en :
    lang === 'ru' ? plan.name_ru :
    plan.name_az;

  return {
    id: plan.id,
    name,
    buildingTypes: plan.building_types ?? [],
    rooms,
    tags,
  };
}
